import { useMutation, useQueryClient } from "@tanstack/react-query";
import { DataLake } from "@graylog/enterprise-api";
import i18n from "i18n";
import UserNotification from "util/UserNotification";
const onUpdateDataLakeRetention = ({ streamId, retentionTime }) => DataLake.setArchiveRetentionTime(streamId, {
  retention_time: retentionTime
});
const useDataLakeRetention = () => {
  const queryClient = useQueryClient();
  const { mutateAsync: onUpdateDataLakeRetentionMutation } = useMutation({
    mutationFn: onUpdateDataLakeRetention,
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ["data-lake-config"]
      });
      UserNotification.success(
        i18n.t("notifications.retention_updated", { ns: "enterprise_data_lake" }),
        i18n.t("notifications.retention_update_title", { ns: "enterprise_data_lake" })
      );
    },
    onError: (errorThrown) => {
      UserNotification.error(
        i18n.t("notifications.retention_update_failed", { ns: "enterprise_data_lake", error: errorThrown }),
        i18n.t("notifications.retention_update_failed_title", { ns: "enterprise_data_lake" })
      );
    }
  });
  return {
    onUpdateDataLakeRetentionMutation
  };
};
export default useDataLakeRetention;
